
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import {standardPublicApi,standardApi} from "@/api/standard";
    import baseUrl, {imageUrl} from "../../constants";
    import {authorizeCertApi} from "@/api/organization";
    const {regionData, CodeToText} =require("@/js/region/region");
    import SelectMechanism from "@/components/SelectMechanism.vue";
    import tempSave from "@/components/TempSave.vue";
    import TableShowRangeBody from "@/components/table-show-range-body.vue";
    import TableShowRangeHead from "@/components/table-show-range-head.vue";
    import TableShowRangeBodyEjian from "@/components/table-show-range-body-ejian.vue";
    @Component({
        name: "standardDetail",
        components: {TableShowRangeBodyEjian, TableShowRangeHead, SelectMechanism, tempSave, TableShowRangeBody}
    })
    export default class Home extends Vue {
        private loading!: boolean;
        title = "公共标准详情";
        pageType = "0";  //0添加  1编辑  2查看
        mode = 0;
        id = "0";
        manageStatus = 0; //0新建 1复查 2改造 3初始 4重建
        regionData = regionData;
        regionDataAll = JSON.parse(JSON.stringify(regionData))
        form = {
            /**
             * '社会公用计量标准证书号'
             */
            certificateNo: "",
            /** 单位ID */
            ownerId: "",
            /** 单位NameID */
            companyNameId: "",
            /**
             * 建标单位
             */
            companyName: "",
            code: '',
            /**
             * 计量标准名称
             */
            name: "",
            /**
             * 计量标准的ID
             */
            measuringId: '',
            /**
             * 测量范围·
             */
            // surveyRange: "",
            /**
             * 不确定度或准确度等级或最大允许误差
             */
            maxError: "",
            /**
             * 不确定度或准确度等级或最大允许误差
             */
            maxErrors: [],
            /**
             * 发证机关别名
             */
            issuingAuthorityNameId: "",
            /**
             * 发证机关
             */
            issuingAuthority: '',
            /**
             * 发证日期
             */
            issuedDate: "",
            /**
             * 有效日期
             */
            termValidity: '',
            /**
             * 使用状态
             */
            useStatus: '',
            /**
             * 传递地区或范围
             */
            transmitAddress: "",
            transmitAddressArr: [],
            transmitAddressText: '',
            /**
             * 计量标准考核证书号
             */
            assessmentCertificateNo: "",
            /**
             * 计量授权证书号
             */
            authorizationCertificateNo: "",
            /**
             * 计量标准考核证书影硬件
             */
            enclosure: "",
            /**
             * 检定或效验项目列表
             */
            measuringItems:[],
            surveyRangesHtml: '',
            accuracyLevelHtml: '',
            /**
             *  测量范围
             */
            measuringScopes: [],
            /**
             * 参数列表 含测量范围 准确度等级
             */
            paramList: [],
            /**
             * 0:待提交
             * 1:未审核
             * 2:已生效
             * 3:未通过
             * */
            status: 0,
            /** 第一次建标时间*/
            firstCreatedYear: "",
        }
        rules = {
            certificateNo: [{ required: true, message: '请输入计量标准证书号', trigger: 'blur' }],
            companyName: [{ required: true, message: '请输入建标单位', trigger: 'blur' }],
            measuringId: [{ required: true, message: '请选择计量标准', trigger: 'blur' }],
            issuingAuthorityNameId: [{ required: true, message: '请选择发证机关', trigger: 'change' }],
            issuedDate: [{ required: true, message: '请选择发证日期', trigger: 'change' }],
            termValidity: [{ required: true, message: '请选择有效期', trigger: 'change' }],
            transmitAddress: [{ required: true, message: '请输入传递地区或范围', trigger: 'blur' }],
            firstCreatedYear: [{required: true, message: '请选择首次建标年份', trigger: 'change'}],
            authorizationCertificateNo: [{ required: true, message: '请输入计量授权证书号', trigger: 'change' }],
            enclosure: [{ required: true, message: '请上传社会公用计量标准证书影印件', trigger: 'change' }]
        }

        standardList = [] as any;
        baseUrl = baseUrl
        headers = {Authorization:""}
        fileList = [] as any;
        private closePage: any;
        dialogImageUrl = "";
        imagePreviewVisible = false;
        accept = ".png,.jpg,.pdf";
        limit = 10;
        listType = "picture-card"
        userData = null as any
        sysPublicUpdate = false; // 社会公用计量标准审核 权限
        showInput = false;
        firstYearIsNull = true;// 首次建标日期是否是空
        review = {
            failText: '',
            failDialog: false,
        }
        fullScreen = false;

        created() {
            this.init();
        }


        getTitle(){
            let title = "";
            if(this.pageType === "0"){
                if(this.manageStatus === 0){
                    title += "新建";
                }else if(this.manageStatus === 1){
                    title += '复查';
                }else if(this.manageStatus === 2){
                    title += '改造';
                }else if(this.manageStatus === 3){
                    title += '初始';
                }else if(this.manageStatus === 4){
                    title += '重建';
                }
            }else if(this.pageType === "1"){
                title += "编辑";
            }else if(this.pageType === "2"){
                title += "查看";
            }else{
                title += "审核";
            }
            title += '社会公用计量标准证书'
            return title;
        }

        haveRight(){
            const right = this.$store.state.userRights;
            right.forEach((e:any)=>{
                if(e.name == "社会公用计量标准审核"){
                    this.sysPublicUpdate = true;
                }
            })
        }
        //改变发证机关
        changeManufactory2(e: any) {
            this.form.issuingAuthorityNameId = e.mechanismNameId;
            this.form.issuingAuthority = e.mechanismName;
        }
        regionCodeToText(values: any){
            let address = "";
            try{
                if(values){
                    for(const arr of values){
                        if(arr){
                            if(address != "")  address += ",";
                            const codes = arr as any;
                            for(const code of codes){
                                const text = CodeToText[code];
                                address += text;
                            }

                        }
                    }
                }
            }catch (e) {
                console.log(e);
            }
            return address;
        }
        changeAddress(values: any){
            this.regionData = JSON.parse(JSON.stringify(this.regionDataAll));
            const addressCodes = [] as any;
            values.forEach((list: any) => {
                const code = list[list.length -1];
                addressCodes.push(code);
            });
            addressCodes.forEach((code: string) => {
                const regionData = this.getRegionData(code, this.regionData);
                this.changeChild(regionData);
            });
        }
        changeChild(regionData: any){
            if(regionData != null && regionData.children != null) {
                regionData.children.forEach((child: any) => {
                    child.disabled = true;
                    if (child.children) {
                        this.changeChild(child);
                    }
                });
            }
        }
        getRegionData(code: string, projectList: any){
            let result = null as any;
            for(let i =0; i<projectList.length; i++){
                const project = projectList[i];
                if(project.value === code){
                    result = project;
                    break;
                }else{
                    if(project.children != null){
                        const r = this.getRegionData(code, project.children);
                        if(r != null){
                            result = r;
                            break;
                        }
                    }
                }
            }
            return result;
        }
        closeFail(){
            setTimeout(() => {
                this.review.failText = "";
            }, 500)
            this.review.failDialog = false;
        }
        hasBtn(mode: string) {
            const pageType = this.pageType;
            const manageStatus = this.manageStatus;
            const {status} = this.form;
            if(mode === 'past'){
                return pageType === "4";
            }else if(mode === 'add'){
                return pageType === '0' || (pageType === '1' && status !== 2)
            }else if(mode === 'tempSave'){
                return pageType === '0' && manageStatus  === 0;
            }else if(mode === 'submit'){
                return ['0', '1'].indexOf(pageType) > -1 && (this.mode === 0)
            }else if(mode === 'audit-save'){
                return ['4'].indexOf(pageType) > -1 || (this.mode === 1 && this.sysPublicUpdate);
            }
        }
        passOrNot(status: number) {
            //通过或不通过
            if (status == 3) {
                //不通过，必须有原因
                if (this.review.failText == "") {
                    this.$message.error("请填写不通过原因");
                    return
                }
            }
            this.onSubmit(1 ,() => {
                authorizeCertApi.updateStatus({ids: this.id, status: status, reason: this.review.failText, type: 2}).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("审核成功，1秒后返回上一页！");

                        let $tempSave = this.$refs.tempSave as HTMLFormElement;
                        if ($tempSave) {
                            $tempSave.deleteUserConfig();
                        }

                        this.closeFail();
                        setTimeout(() => {
                            this.closePage()
                        }, 1000);
                    }
                })
            });

        }

        init(){
            this.haveRight();
            const userData = this.$store.state.AuthedUser;
            this.userData = userData;
            this.loading = false;
            if(this.$route.path.indexOf('external') !== -1){
                this.fullScreen = true;
            }
            this.manageStatus = Number(this.$route.params.manageStatus);
            this.pageType = this.$route.params.type;
            this.mode = Number(this.$route.params.mode);
            this.id = this.$route.params.id;
            this.headers.Authorization = this.$store.state.Authorization;
            if ((this.pageType !== '0') || (this.pageType === '0' && this.id !== '' &&this.id !== '0')) {
                this.getStandard();
            }else{
                this.form.companyName = userData.organizationName;
                if(userData.mechanismNames != null && userData.mechanismNames.length > 0){
                    this.form.companyNameId = userData.mechanismNames[0].id;
                    this.form.ownerId = userData.mechanismNames[0].mechanismId;
                    this.pageStandard();
                }
            }
        }
        findName(){
            let str = "";
            try{
                const obj = this.standardList.find((e:any)=> e.id == this.form.measuringId);
                if(obj){
                    str = obj.name;
                }
            }catch (e) {
                console.log(e);
            }
            return str;
        }
        //上传监控
        handleAvatarSuccess(res: any, file: any) {
            if(res.result === 0){
                const rData = res.data;
                // this.fileList.push({name: file.name,url: imageUrl+rData})
                this.fileList.push({name: "社会公用计量标准证书.pdf",url: imageUrl+rData})
                this.uploadConfig();
            }
        }
        //控制上传组件参数
        uploadConfig(){
            if(this.fileList.length == 0){
                this.accept = ".png,.jpg,.pdf";
                this.limit = 10;
                this.listType = "picture-card"
            }else{
                const fix = this.filesuffix(this.fileList[0].url);
                if(fix == "jpg" || fix == "png"){
                    this.accept = '.png,.jpg';
                }else{
                    this.accept = '.pdf';
                    this.limit = 1;
                    this.listType = "text";
                }
            }
        }
        handleRemove(file:any, fileList:any) {
            const index = this.fileList.findIndex((e:any)=>e.url === file.url);
            if(index > -1){
                this.fileList.splice(index,1);
            }
            this.uploadConfig();
        }
        handlePictureCardPreview(file: any) {
            const fix = this.filesuffix(file.url);
            if(fix == "pdf"){
                window.open(baseUrl + "/file/download?file=" + file.url.replace(imageUrl,"") + "&name=" + file.name, '_blank');
            }else{
                this.dialogImageUrl = file.url;
                this.imagePreviewVisible = true;
            }
        }
        //上传监控
        beforeAvatarUpload(file: any) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            const isPDF = file.type === 'application/pdf';

            if (!isJPG && !isPNG && !isPDF) {
                this.$message.error('上传图片只能是 JPG 或 PNG 或 PDF格式!');
            }
            return (isJPG||isPNG||isPDF);
        }
        filesuffix(fileName: string){
            const first = fileName.lastIndexOf(".");//取到文件名开始到最后一个点的长度
            const namelength = fileName.length;//取到文件名长度
            const filesuffix = fileName.substring(first + 1, namelength );//截取获得后缀名
            return filesuffix;
        }
        getStandard(){
            standardPublicApi.getStandard({id:this.id}).then((r: any) => {
                if (r.data.result === 0) {
                    this.form = r.data.data;
                    this.form.useStatus = r.data.data.useStatus.value;
                    this.form.status = r.data.data.status.value;
                    this.firstYearIsNull = (r.data.data.firstCreatedYear ? false : true);
                    try{
                        this.form.transmitAddressArr = JSON.parse(this.form.transmitAddress);
                        this.changeAddress(this.form.transmitAddressArr);
                    }catch (e) {
                        this.form.transmitAddressArr = [];
                    }
                    if(this.pageType === '0'){
                      this.form.companyName = this.userData.organizationName;
                    }
                  this.getTable();
                    this.pageStandard();

                    if(this.form.enclosure){
                        this.fileList = [];
                        try {
                            var obj=JSON.parse(this.form.enclosure);
                            if(typeof obj == 'object' && obj ){
                                for(let i = 0; i < obj.length; i++){
                                    this.fileList.push({name: obj[i].name ,url: imageUrl+obj[i].url})
                                }
                                this.uploadConfig();
                            }
                        } catch(e) {
                            const arr = this.form.enclosure.split(",");
                            for(let i = 0; i < arr.length; i++){
                                this.fileList.push({name:"证书文件",url: imageUrl+arr[i]})
                            }
                            this.uploadConfig();
                        }
                    }
                }
            })
        }
        changeStandard(item : any){
            this.showInput = false;
            const changeFrom = this.form;
            changeFrom.code = item.code;
            changeFrom.useStatus = item.useStatus.value;
            changeFrom.issuedDate = item.issuedDate;
            changeFrom.termValidity = item.termValidity;
            changeFrom.assessmentCertificateNo = item.certificateNo;
            this.getTable();
        }
        clickDiv(){
            this.showInput=true;
            this.$nextTick(()=>{
                let $table = this.$refs.myselect as HTMLFormElement;
                console.log($table)
                $table.focus();
            })
        }
        showInputFun(){
            setTimeout(()=>{
                this.showInput=false;
            },200)
        }
        pageStandard(){
            const params = {
                ownerId: this.form.ownerId,
                appendMeasuringIds: [this.form.measuringId].join(","),
                manageStatus: this.manageStatus,
                pageType: this.pageType
            }
            standardApi.listUnBindStandard(params).then((r: any) => {
                if (r.data.result === 0) {
                    this.standardList = r.data.data;
                }
            })

          if(this.pageType === '0'){
            if([1, 2, 4].includes(this.manageStatus)){
              this.form.measuringId = "";
            }
          }
        }

        //改变建标单位
        changeCompany(e: any){
            this.form.companyName = e.mechanismName;
            this.form.companyNameId = e.mechanismNameId;
            this.form.ownerId = e.mechanismId;
            this.form.measuringId = "";
            this.form.name = "";
            this.pageStandard();
        }

        getTable() {
            standardApi.getMeasuringStandard({id: this.form.measuringId}).then((r: any) => {
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    const items = r.data.data.measuringItems;
                    const changeFrom = this.form;
                    let paramList = r.data.data.paramList;
                    changeFrom.paramList = paramList;
                    changeFrom.code = r.data.data.measuringStandard.code;
                    const measuringItems = [] as any;
                    items.forEach((item: any) => {
                        const paramList = JSON.parse(item.surveyRangesJson);
                        measuringItems.push({
                            id: item.id,
                            measuringId: item.measuringId,
                            projectId: item.projectId,
                            firstChild: true,
                            name: item.name,
                            paramList: paramList,
                            surveyRangesHtml: item.surveyRangesHtml,
                            accuracyLevelHtml: item.accuracyLevelHtml,
                        });
                    });
                  this.form.measuringItems = measuringItems;
                  this.$set(this.form, 'surveyRangesHtml', rData.measuringStandard.surveyRangesHtml);
                  this.$set(this.form, 'accuracyLevelHtml', rData.measuringStandard.accuracyLevelHtml);
                }
            })
        }

        calcManageStatus(){
            if(this.manageStatus === 0 || this.manageStatus === 3){
                const date = new Date(this.form.firstCreatedYear);
                if(date.getFullYear() < new Date().getFullYear()){
                    return 3;
                }else{
                    return 0;
                }
            }
            return this.manageStatus;
        }


        onSubmit(submitType: number, callback: any) {
            this.form.enclosure = "";
            this.form.transmitAddress = "";
            if (this.form.transmitAddressArr.length > 0) {
                this.form.transmitAddress = JSON.stringify(this.form.transmitAddressArr);
            }
            this.form.transmitAddressText = this.regionCodeToText(this.form.transmitAddressArr);
            let enclosureList = this.fileList.map((e: any) => {
                return {
                    name: e.name,
                    url: e.url.replace(imageUrl, "")
                }
            });
            this.form.enclosure = enclosureList.length === 0 ? "" :  JSON.stringify(enclosureList);
            let params = this.form as any;
            if (this.id != "0") {
                params = Object.assign(params, {id: this.id})
            }
            if (this.limit == 1) {
                //证明文件是pdf
                params.pdfPath = params.enclosure;
            }
            this.formVerification(submitType, () => {
                const loading = this.$loading({
                    text: '正在保存',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                if (this.form.status == 2 && this.sysPublicUpdate && this.mode === 1) {
                    submitType = 2;
                }
                params.submitType = submitType;
                if(this.pageType === '0'){
                    params.id = null;
                    params.manageStatus = this.calcManageStatus();
                    params.shareStatus = 0;
                    params.agingStatus = 1;
                    if([1,2, 4, 5].indexOf(this.manageStatus) > -1){
                      params.replaceId = this.id;
                    }
                }
                standardPublicApi.update(params).then((r: any) => {
                    if (r.data.result == 0) {
                        let $tempSave = this.$refs.tempSave as HTMLFormElement;
                        if ($tempSave) {
                            $tempSave.deleteUserConfig();
                        }

                        if (callback) {
                            callback();
                        } else {
                            this.$message.success("保存成功");
                            this.closePage();
                        }
                    }
                    loading.close();
                })
            });
        }

        formVerification(submitType: number, callback: any) {
            //不通过  不做校验
            if (submitType == 3) {
                callback();
                return;
            }
            let form = this.$refs.form as HTMLFormElement;
            form.validate((valid: any) => {
                if (valid) {
                    callback();
                }else {
                    this.$message.warning("未填写完整信息");
                }
            });

        }

        clearForm() {
            const options = this.$options as any;
            Object.assign(this.$data, options.data.call(this));
            this.init();
        }
        getTempData(e: any) {
            if(!e) return;
            const rData = JSON.parse(e);
            this.form = rData.form;
            if (rData.fileList) {
                this.fileList = rData.fileList;
                const enclosureList = this.fileList.map((e: any) => {
                    return {
                        name: e.name,
                        url: e.url.replace(imageUrl, "")
                    }
                });
                this.form.enclosure = JSON.stringify(enclosureList);
            }
        }

      isDisabled(mode: string){
       if(mode === 'block-1-firstCreatedYear') {
          return (['2'].indexOf(this.pageType) > -1);
        }
      }
    }
